import { Box, Drawer } from '@material-ui/core';
import PropTypes from 'prop-types';
import QuickReport from './QuickReport.component';

const RightPanel = (props) => {
	const { show, setShow, isTooltipCheck, setIsTooltipCheck } = props;

	return (
		<Box>
			<Drawer
				open={show}
				anchor="right"
				variant="persistent"
				id={'template-drawer'}
				PaperProps={{ style: { zIndex: 99 } }}>
				<QuickReport
					setShow={setShow}
					show={show}
					isTooltipCheck={isTooltipCheck}
					setIsTooltipCheck={setIsTooltipCheck}
				/>
			</Drawer>
		</Box>
	);
};

RightPanel.propTypes = {
	setShow: PropTypes.func.isRequired,
	show: PropTypes.bool.isRequired
};

export default RightPanel;
